import { STORAGE_ORDER } from '@blocks/constants';

import getDefaultStorage from './getDefaultStorage';
import { isBrowser } from '.';

const getStoredOrderValues = () => {
  if (isBrowser()) {
    const storedData = getDefaultStorage().getItem(STORAGE_ORDER);
    if (storedData) {
      const storedValues = JSON.parse(storedData)?.state?.order;
      return storedValues;
    }
    return {};
  }
  return {};
};

export default getStoredOrderValues;
